/* src/app/components/doc-viewer-new/dialogs/custom-ai-prompt-dialog/custom-ai-prompt-dialog.component.scss */
.grey-header,
.grey-header-below,
.grey-header-right,
lex-text-input[label=Title],
.not-edit-list *:not(i),
.search-box,
.check-box-label,
.header {
  color: #000;
}
:host-context(.dark-theme) .grey-header,
:host-context(.dark-theme) .grey-header-below,
:host-context(.dark-theme) .grey-header-right,
:host-context(.dark-theme) lex-text-input[label=Title],
:host-context(.dark-theme) .not-edit-list *:not(i),
:host-context(.dark-theme) .search-box,
:host-context(.dark-theme) .check-box-label,
:host-context(.dark-theme) .header {
  color: #fff;
}
.column {
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: flex-start;
}
.header {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}
.sub-header {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
.more-vert-button {
  float: right;
  width: 36px;
  height: 36px;
}
.more-vert-icon {
  float: right;
  font-size: 16px;
  margin-right: 4px;
}
.search-box {
  width: 100%;
  margin-left: 10px;
  margin-right: 30px;
}
.title {
  font-size: 10px;
  color: rgba(0, 0, 0, 0.54);
}
.more-action-button {
  font-size: 12px;
  line-height: 36px;
  height: 36px;
}
.prompt-list-column {
  margin: 0px 10px 0px 10px;
  display: flex;
  width: 100%;
  flex-direction: column;
  border-right: solid 1px #ccc;
}
.prompt-list-selected-item {
  border-left: 4px solid rgb(63, 81, 181);
  background: rgba(57, 73, 171, 0.08);
  cursor: default;
  font-size: 14px;
  height: 35px;
  cursor: pointer;
}
.prompt-list-row-item {
  background-color: white;
  border-left-style: solid;
  border-left-color: white;
  border-left-width: thick;
  font-size: 14px;
  height: 35px;
  cursor: pointer;
}
.icon-button-line {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
}
.not-edit-list .prompt-list-selected-item,
.not-edit-list .prompt-list-row-item {
  border-bottom: 1px rgba(0, 0, 0, 0.12) solid;
}
.dark-theme-menu-item {
  margin: -8px 0;
  padding: 8px 0;
  background-color: #424242;
  color: #FFFFFF;
}
.docs-node {
  color: rgb(36, 62, 144);
}
.grey-header-right {
  align-self: center;
}
:host-context(.dark-theme) .docs-node {
  --fa-primary-color: #FFC107;
  --fa-secondary-color:#909090;
  --fa-secondary-opacity: 1 ;
}
:host-context(.dark-theme) .grey-header {
  background-color: #262626;
}
:host-context(.dark-theme) .grey-header-below {
  background-color: #262626;
}
:host-context(.dark-theme) ::placeholder {
  color: rgba(255, 255, 255, 0.5);
}
:host-context(.dark-theme) .title {
  color: rgba(255, 255, 255, 0.5);
}
:host-context(.dark-theme) .mat-mdc-input-element {
  color: #FFFFFF;
  caret-color: #9fa8da !important;
}
:host-context(.dark-theme) .mat-mdc-input-element:disabled {
  color: rgba(255, 255, 255, 0.5);
}
:host-context(.dark-theme) .prompt-list-selected-item {
  border-left: 4px solid #ffc107;
  background: rgba(0, 0, 0, 0.32);
  color: #FFFFFF;
  border-bottom: 1px rgba(91, 91, 91, 0.9) solid;
}
:host-context(.dark-theme) .prompt-list-row-item {
  background-color: #424242;
  border-left-color: #424242;
  color: #FFFFFF;
  border-bottom: 1px rgba(91, 91, 91, 0.9) solid;
}
:host-context(.dark-theme) ::ng-deep ::-webkit-scrollbar {
  height: 12px;
  width: 15px;
}
:host-context(.dark-theme) ::ng-deep ::-webkit-scrollbar-thumb {
  -webkit-border-radius: 6px;
  background: #ffc107;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  background-clip: padding-box;
}
:host-context(.dark-theme) ::ng-deep ::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.2);
  background-clip: padding-box;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
}
:host-context(.dark-theme) ::ng-deep ::-webkit-scrollbar-corner {
  background: #000;
}
/*# sourceMappingURL=custom-ai-prompt-dialog.component.css.map */
